import {
  Box,
  CircularProgress,
  SxProps,
  Stack,
  Typography,
} from "@mui/material";
import { DRAWER_WIDTH } from "base/constant/ui";
import useBreakpoint from "base/hooks/useBreakpoint";

interface Props {
  type?: "page" | "component";
  size?: keyof typeof SIZE_MAP;
  padding?: number;
  isFullPage?: boolean;
  loadingResource?: string;
}

const SIZE_MAP = {
  extraSmall: 10,
  smaller: 15,
  small: 20,
  medium: 40,
  large: 60,
};

const Loader = ({
  type = "component",
  size = "medium",
  padding = 4,
  isFullPage = false,
  loadingResource,
}: Props) => {
  const { isGreaterThanMd } = useBreakpoint();

  const pageLoaderStyles: SxProps = {
    position: "fixed",
    top: "50%",
    left: isFullPage
      ? "50%"
      : `calc(50% + ${isGreaterThanMd ? DRAWER_WIDTH / 2 : 0}px)`,
    transform: "translate(-50%, -50%)",
  };
  const componentLoaderStyles: SxProps = {
    padding: padding,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100%",
  };

  return (
    <Box
      className="loader-wrapper"
      sx={type === "page" ? pageLoaderStyles : componentLoaderStyles}
    >
      <Stack spacing={1} justifyContent={"center"} alignItems={"center"}>
        <CircularProgress size={SIZE_MAP[size]} />
        {loadingResource && <Typography>{loadingResource}</Typography>}
      </Stack>
    </Box>
  );
};

export default Loader;
